<template>
    <div>
        <b-card>
            <div class="d-flex justify-content-between align-items-center flex-wrap mb-1">
                <div class="mb-md-0">
                    <b-button
                        variant="primary"
                        :disabled="selectedRows.length === 0"
                        @click="approveSelected"
                    >
                        Approve Selected ({{ selectedRows.length }})
                    </b-button>
                </div>

                <!-- <div class="d-flex align-items-center">
                    <b-form-group
                        label="Sort by:"
                    >
                        <b-form-select v-model="sortOrder" :options="[
                            { value: 'DESC', text: 'Newest First' },
                            { value: 'ASC', text: 'Oldest First' }
                        ]" @change="fetchPropertyData" />
                    </b-form-group>
                </div> -->
            </div>
            <div v-if="isLoading" class="text-center p-5">
                Loading properties...
            </div>
            <b-table
                v-else
                ref="refPropertyListTable"
                :items="propertyListData"
                responsive
                striped
                :fields="tableColumns_property"
                :sort-by.sync="sortBy"
                :sort-desc.sync="isSortDirDesc"
                show-empty
                empty-text="No matching records found"
                class="position-relative"
            >
                <template #head(selected)>
                    <b-form-checkbox v-model="allSelected" @change="toggleSelectAll"></b-form-checkbox>
                </template>

                <template #cell(selected)="data">
                    <b-form-checkbox v-model="selectedRows" :value="data.item.id"></b-form-checkbox>
                </template>

                <template #cell(image)="data">
                    <b-link
                    variant="flat-primary"
                    class="pb0"
                    :to="{ name: 'property-upload', params: { id: data.item.id } }"
                >
                    <b-img
                    class="img_property"
                    :src="data.item.coverImage
                        ? data.item.coverImage 
                        : 'https://findbangkokroom.com/public/img/storage/1698858264911-picture.png'"
                    fluid
                    />
                </b-link>
                </template>
                <template #cell(units)="data">
                    {{ data.item.units }} 
                    {{ data.item.address_no }}
                </template>
                <template #cell(property)="data">
                    <div class="list-property">
                        <router-link :to="{ name: 'property-edit', params: { id: data.item.id } }" >{{ data.item.property_code }}</router-link>
                        <br />
                        {{ formatDate(data.item.availble_date, {  day: 'numeric', month: 'short', year: 'numeric' }) }}
                        <br />
                    </div>
                </template>
                <template #cell(rent_price)="data">
                    {{ data.item.rent_price | getcomma }}
                </template>
                <template #cell(sale_price)="data">
                    {{ data.item.sale_price | getcomma }}
                </template>
                <template #cell(owner)="row">
                    <span class="vs-label">{{ row.item.owner_firstname  }} {{ row.item.owner_lastname  }}</span>
                </template>
                <template #cell(actions)="data">
                    <span>
                        <b-dropdown
                            variant="link"
                            toggle-class="text-decoration-none"
                            no-caret
                        >
                            <template v-slot:button-content>
                                <feather-icon
                                    icon="MoreVerticalIcon"
                                    size="16"
                                    class="text-body align-middle mr-25"
                                />
                            </template>
                            <b-dropdown-item @click="onConfirm(data.item.id)"> 
                                <feather-icon
                                    icon="CheckCircleIcon"
                                    class="mr-50"
                                />
                                <span>Approve</span>
                            </b-dropdown-item>
                            <b-dropdown-item :to="{ name: 'property-edit', params: { id: data.item.id } }"> 
                                <feather-icon
                                    icon="Edit2Icon"
                                    class="mr-50"
                                />
                                <span>Detail</span>
                            </b-dropdown-item>
                            <b-dropdown-item  @click="deleteconfirm(data.item.id)"> 
                                <feather-icon
                                    icon="TrashIcon"
                                    class="mr-50"
                                />
                                <span>Delete</span>
                            </b-dropdown-item>
                        </b-dropdown>
                    </span>
                </template>
            </b-table>
            <div class="mx-2 mb-2">
                <b-row>
                    <b-col cols="12" sm="6"
                        class="d-flex align-items-center justify-content-center justify-content-sm-start">
                        <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
                    </b-col>

                    <b-col cols="12" sm="6"
                        class="d-flex align-items-center justify-content-center justify-content-sm-end">
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="totalProperty"
                            :per-page="perPage"
                            first-number
                            last-number
                            class="mb-0 mt-1 mt-sm-0"
                            prev-class="prev-item"
                            next-class="next-item"
                        >
                            <template #prev-text>
                                <feather-icon
                                    icon="ChevronLeftIcon"
                                    size="18"
                                />
                            </template>
                            <template #next-text>
                                <feather-icon
                                    icon="ChevronRightIcon"
                                    size="18"
                                />
                            </template>
                        </b-pagination>
                    </b-col>
                </b-row>
            </div>
            <div class="d-flex justify-content-between align-items-center flex-wrap mb-1">
                <div class="mb-md-0">
                    <b-button
                        variant="primary"
                        :disabled="selectedRows.length === 0"
                        @click="approveSelected"
                    >
                        Approve Selected ({{ selectedRows.length }})
                    </b-button>
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>
import {
    BCard, BRow, BCol, BFormInput, BFormCheckbox, BButton, BTable, BMedia, BAvatar, BLink, BBadge, BDropdown, BDropdownItem, 
    BPagination, BTooltip, BImg, VBToggle, BSidebar, BButtonToolbar, BButtonGroup, BFormGroup, BFormSelect,
} from 'bootstrap-vue'
import store from '@/store'
import axios from '@axios'
import { ref, watch, computed, onUnmounted } from '@vue/composition-api'
import propertyStoreModule from '../propertiesStoreModule'
import { filterTags, formatDate } from '@core/utils/filter'
import { onMounted, nextTick } from 'vue'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
    components: {
        BCard, BRow, BCol, BFormInput, BFormCheckbox, BButton, BTable, BMedia, BAvatar, BLink, BBadge, BDropdown, BDropdownItem,
        BPagination, BTooltip, BImg, BButtonToolbar,  BButtonGroup, VBToggle, BSidebar, BFormGroup, BFormSelect,
    },

    filters: {
        getcomma: function(text){
            if(!text){
                return ''
            }

            var nStr = text;
            nStr += '';
            var x = nStr.split('.');
            var x1 = x[0];
            var x2 = x.length > 1 ? '.' + x[1] : '';
            var rgx = /(\d+)(\d{3})/;

            while (rgx.test(x1)) {
                x1 = x1.replace(rgx, '$1' + ',' + '$2');
            }

            return x1 ;
        },
    },
    setup(){
        const PROPERTY_MODULE = 'app-property';
        if (!store.hasModule(PROPERTY_MODULE)) store.registerModule(PROPERTY_MODULE, propertyStoreModule);
        onUnmounted(() => store.hasModule(PROPERTY_MODULE) && store.unregisterModule(PROPERTY_MODULE));

        const tableColumns_property = [
            { key: 'selected', label: '', sortable: false, tdClass: 'text-center', thClass: 'text-center' },
            { key: 'image', label: 'Image', sortable: false, tdClass:'tb-image'},
            { 
                key: 'property',
                label: 'Property', 
                sortable: false ,
                filterOptions: {
                    enabled: true,
                    placeholder: 'Search Name',
                },
            },
            { key: 'owner',label: 'Owner', sortable: false },
            { key: 'units',label: 'House No Unit', sortable: true },
            { key: 'floors',label: 'Floor', sortable: true },
            { key: 'type_name',label: 'Type', sortable: true },
            { key: 'buildiing',label: 'Building', sortable: true },
            { key: 'bedroom',label: 'Br', sortable: true },
            { key: 'sqm',label: 'Sqm', sortable: true },
            { key: 'rent_price',label: 'Rent', sortable: true },
            { key: 'sale_price',label: 'Sale', sortable: true },
            { key: 'actions' },
        ]

        const dataMeta = computed(() => {
            const localItemsCount = refPropertyListTable.value ? refPropertyListTable.value.localItems.length : 0
            return {
                from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
                to: perPage.value * (currentPage.value - 1) + localItemsCount,
                of: totalProperty.value,
            }
        })

        const currentPage = ref(1)
        const totalProperty = ref(0)
        const perPage = ref(25)
        const refPropertyListTable = ref(null)
        const sortBy = ref('id')
        const isSortDirDesc = ref(true)
        const propertyListData = ref([])
        const propertyImageData = ref([])
        const toast = useToast()
        const isLoading = ref(true)
        const sortOrder = ref('DESC')
        const selectedRows = ref([])
        const allSelected = ref(false)

        const toggleSelectAll = () => {
            if (allSelected.value) {
                selectedRows.value = propertyListData.value.map(p => p.id)
            } else {
                selectedRows.value = []
            }
        }

        const approveSelected = async () => {
            if (selectedRows.value.length === 0) return
            try {
                await store.dispatch('app-property/approvePropertyLists', selectedRows.value)

                toast({
                    component: ToastificationContent,
                    props: {
                        title: "Approved Successfully",
                        icon: 'CheckCircleIcon',
                        variant: 'success',
                    },
                })

                fetchPropertyData()
                selectedRows.value = []
                allSelected.value = false
            } catch (e) {
                toast({
                    component: ToastificationContent,
                    props: {
                        title: "Error Approving Properties",
                        icon: 'AlertTriangleIcon',
                        variant: 'danger',
                    },
                })
            }
        }

        const onConfirm = async (id) => {
            try {
                await store.dispatch('app-property/approvePropertyLists', [id])

                toast({
                    component: ToastificationContent,
                    props: {
                        title: `Property #${id} Approved`,
                        icon: 'CheckCircleIcon',
                        variant: 'success',
                    },
                })

                fetchPropertyData()
            } catch (e) {
                toast({
                    component: ToastificationContent,
                    props: {
                        title: "Error Approving Property",
                        icon: 'AlertTriangleIcon',
                        variant: 'danger',
                    },
                })
            }
        }

        const fetchPropertyData = async () => {
            isLoading.value = true
            const offset = perPage.value * (currentPage.value-1);
            
            try {
                const response = await store.dispatch('app-property/fetchProperties', {
                    perpage: 25,
                    offset: offset,
                    is_approve: 0,
                    order_by: `ID ${sortOrder.value}`
                })

                propertyListData.value = response?.data?.data || []
                totalProperty.value = response?.data?.total || 0

                await Promise.all(
                    propertyListData.value.map(async (property) => {
                        property.coverImage = await fectchCoverImageData(property.id)
                    })
                );
            } catch(error) {
                console.error("Error fetching properties:", error);
            } finally {
                isLoading.value = false
            }
        }

        const fectchCoverImageData = async (id) => {
            const { data } = await axios.get(`property/v1/coverimage/${id}`)

            const images = data.data

            const findCoverImage = images.find(v => v.is_cover == 1)

            return findCoverImage? findCoverImage.src: ''
        }

        fetchPropertyData()

        const deleteData = (id) => {
            store.dispatch('app-property/fetchDeleteProperty',id).then(response=>{
                toast({
                    component: ToastificationContent,
                    props: {
                    title: "Delete Success",
                    icon: 'AlertTriangleIcon',
                    variant: 'success',
                    },
                })

                fetchPropertyData();
            }).catch((err)=>{
                toast({
                    component: ToastificationContent,
                    props: {
                    title: "Error Delete Property",
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                    },
                })
            })
        }

        // onMounted(() => {
        //     fetchPropertyData
        // })

        return {
            fetchPropertyData,
            propertyListData,
            tableColumns_property,
            sortBy,
            isSortDirDesc,
            formatDate,
            dataMeta,
            refPropertyListTable,
            perPage,
            totalProperty,
            currentPage,
            propertyImageData,
            fectchCoverImageData,
            deleteData,
            isLoading,
            sortOrder,
            selectedRows,
            allSelected,
            toggleSelectAll,
            approveSelected,
            onConfirm,
        }
    },
    methods: {
        deleteconfirm(id){
            this.$bvModal
                .msgBoxConfirm('Please confirm that you want to delete Property ID.', {
                    title: 'Please Confirm',
                    size: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    cancelVariant: 'outline-secondary',
                    hideHeaderClose: false,
                    centered: true,
                })
                .then(value => {
                    if(value === true){
                        this.deleteData(id)
                    }
                })
        }
    }
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
.invoice-filter-select {
  min-width: 190px;
  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }
  ::v-deep .vs__selected {
    width: 100px;
  }
}
::v-deep .table-responsive {
  overflow-x: auto;
}
.tb-image {
  min-width: 120px;
}
.img_property { max-width: 100px; border-radius: 5px; }
</style>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-select.scss';
    @import '@core/scss/vue/libs/vue-sweetalert.scss';
</style>